import { useFieldArray, useFormContext, useWatch } from "react-hook-form";
import { useParams } from "react-router-dom";
import { IPreOrderQuotaSetting } from "../../../../../types/Inventory/PreOrderQuota";
import { useTranslation } from "react-i18next";
import { useEffect, useState } from "react";
import PreOrderQuotaSettingSelectBranchTable from "../../../../Table/Inventory/PreOrderQuota/SelectBranch";
import CustomizedButton from "../../../../Custom/CustomizedButton";
import { useModal } from "../../../../../hooks/use-modal";
import CheckedBranchModal from "../../../../UI/Modal/CheckedBranchModal";
import { Box, FormHelperText } from "@mui/material";
import { useDisable } from "../../../../../hooks/use-disable";
import { usePreOrderQuotaSetting } from "../../../../../hooks/Inventory/use-preorder-quota-setting";

const PreOrderQuotaSettingSelectBranch = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<IPreOrderQuotaSetting>();
  const { id } = useParams();
  const { t } = useTranslation();
  const [disabled] = useDisable();
  const { updateQuotaItemList } = usePreOrderQuotaSetting();

  const { fields, replace, remove } = useFieldArray({
    control,
    name: "branch_list",
  });

  const lockRows = useWatch({
    control,
    name: "locked_branch_unique_id_list",
  });

  const [branchIds, setBranchIds] = useState<string[]>([]);
  const [branchIdsSnapshot, setBranchIdsSnapshot] = useState<string[]>([]);

  const { modal, closeModalHandler, openModalHandler } = useModal();

  const addBranchHandler = (data: any) => {
    replace(data.map((branch: any, index: number) => ({ ...branch, index })));
    updateQuotaItemList();
    closeModalHandler();
  };

  const onRemoveHandler = (index: number) => {
    remove(index);
    updateQuotaItemList();
  };

  useEffect(() => {
    if (fields && fields.length > 0) {
      const uniqueIdList = fields.map(({ unique_id }) => unique_id);
      setBranchIds(uniqueIdList);
      setBranchIdsSnapshot(uniqueIdList);
    } else {
      setBranchIds([]);
      setBranchIdsSnapshot([]);
    }
  }, [fields]);

  return (
    <>
      <Box mt={1}>
        <PreOrderQuotaSettingSelectBranchTable
          rowData={fields}
          onRemoveHandler={onRemoveHandler}
          lockRows={lockRows}
        />
        {!disabled && (
          <CustomizedButton
            variant="outlined"
            title={`${t("button.add")}${t("branch.index")}`}
            onClick={openModalHandler}
            addIcon
          />
        )}
        {Boolean(errors.branch_list) && (
          <FormHelperText error sx={{ mt: 1 }}>
            {errors.branch_list?.message}
          </FormHelperText>
        )}
      </Box>
      <CheckedBranchModal
        branchIds={branchIds}
        branchIdsSnapshot={branchIdsSnapshot}
        setBranchIds={setBranchIds}
        setBranchIdsSnapshot={setBranchIdsSnapshot}
        showSelectBranch={modal}
        rowSelection="multiple"
        closeBranchTable={closeModalHandler}
        finishBranchSelect={addBranchHandler}
        useAltButtons
        titleColor={"#333333"}
        lockRows={id ? lockRows : undefined}
      />
    </>
  );
};

export default PreOrderQuotaSettingSelectBranch;
